module.exports = __webpack_public_path__ + "img/pic-list1.e629ea7e.jpg";